import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './auth/service';
import { AppRoutingService } from './main/services/app-routing/app-routing.service';
import { LoaderService } from '@services/loader/loader.service';

@Component({
    selector: 'app-app-dispatcher',
    templateUrl: './app-dispatcher.component.html',
    standalone: false,
})
export class AppDispatcherComponent implements OnInit {
    constructor(
        private authenticationService: AuthenticationService,
        private appRoutingService: AppRoutingService,
        private loader: LoaderService,
    ) {}

    ngOnInit(): void {
        this.loader.setLoading(true);
        this.authenticationService.isLoggedIn().subscribe((isLogged) => {
            this.loader.setLoading(false);
            if (isLogged) {
                this.appRoutingService.onSignedIn();
            } else {
                this.appRoutingService.navigateToLoginPage();
            }
        });
    }
}
